import { $api } from "@/shared/api";

// Матч пользователя: шапка экрана и id его разбора.
export const matchQueryOptions = (matchId: number) =>
  $api.queryOptions("get", "/api/matches/{match_id}", {
    params: { path: { match_id: matchId } },
  });
